import { createTheme, alpha } from '@mui/material/styles';

// Create a theme instance for Fence Sketch

const theme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 800,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    typography: {
      heading: {
        primary: '#3F3F3F'
      },
      text: {
        primary: '#FFFFFF',
        secondary: '#657884'
      },
      reverse: {
        primary: '#FFFFFF',
        secondary: '#C1C9CE'
      }
    },
    interactions: {
      interactive: {
        default: '#ED5521',
        hover: '#D13A08'
      },
      subtle: {
        default: '#657884',
        hover: '#424E56'
      },
      destructive: {
        default: '#DC3545',
        hover: '#BD2130'
      },
      disabled: {
        default: '#B5B5B5',
        secondary: '#E1E1E1'
      },
      focus: {
        default: '#FFC107',
        hover: '#E0A800'
      }
    },
    status: {
      critical: { default: '#C94221', surface: '#FFE2DB', onSurface: '#801900' },
      warning: { default: '#DDC30F', surface: '#FAF6DB', onSurface: '#907F0A' },
      success: { default: '#7DB00E', surface: '#ECF3DB', onSurface: '#517209' },
      informative: { default: '#3CA2E0', surface: '#E2F1FA', onSurface: '#276992' },
      inactive: { default: '#4D6974', surface: '#D9DFE1', onSurface: '#011B25' }
    },
    surfaces: {
      surface: { default: '#FFFFFF', hover: '#FAF6DB', active: '#ECF3DB' },
      background: '#FFFFFF',
      reverse: '#012939',
      darkBackground: '#151515'
    },
    overlay: {
      default: '#ADADAD',
      dimmed: '#FFFFFF'
    },
    borders: {
      border: '#E1E1E1',
      section: '#012939'
    },
    brand: {
      brand: '#ED5521',
      highlight: '#A0D72A',
      secondary: '#151515'
    }
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h2',
          h4: 'h2',
          h5: 'h2',
          h6: 'h2',
          subtitle1: 'h2',
          subtitle2: 'h2',
          body1: 'span',
          body2: 'span'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          color: theme.palette.brand.brand,
          textTransform: 'none'
        }),
        contained: ({ ownerState, theme }) => ({
          backgroundColor: theme.palette.brand.brand,
          color: theme.palette.typography.reverse.primary,
          '&:hover': {
            backgroundColor: theme.palette.brand.brand,
            color: theme.palette.typography.reverse.primary,
            opacity: 0.9
          }
        }),
        outlined: ({ ownerState, theme }) => ({
          color: theme.palette.brand.brand,
          borderColor: theme.palette.borders.border,
          '&:hover': {
            borderColor: theme.palette.brand.brand,
            backgroundColor: theme.palette.surfaces.surface.hover
          }
        })
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          '&.Mui-focused': {
            borderColor: theme.palette.borders.border,
            color: theme.palette.brand.brand,
            '&.Mui-focused fieldset': {
              color: theme.palette.brand.brand,
              borderColor: theme.palette.brand.brand
            }
          },
          '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.brand.brand
          }
        })
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          '&.Mui-focused': {
            color: theme.palette.brand.brand
          }
        })
      }
    }
  },
  typography: {
    fontFamily: ['Montserrat, sans-serif']
  }
};

export default theme;
